module.exports = __webpack_public_path__ + "img/26_21.6f4d5f7b.png";